import React, { Component } from 'react'
import { connect } from 'react-redux'

import { actualizarDatosParaMuiTable } from '../actions/TablaDetalleEspacioPorCerealLinea12Actions'
import { TablaDetalleEspacioPorCerealLinea12View } from '../components/TablaDetalleEspacioPorCerealLinea12View'

class TablaDetalleEspacioPorCerealLinea12 extends Component {
  componentDidMount () {
    this.props.actualizarDatosParaMuiTable()
  }

  render () {
    return <TablaDetalleEspacioPorCerealLinea12View />
  }
}

const mapActionsToProps = {
  actualizarDatosParaMuiTable
}
const withRedux = connect(null, mapActionsToProps)

export default withRedux(TablaDetalleEspacioPorCerealLinea12)
